import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef, useState } from 'react';
import { Play, X } from 'lucide-react';

export const BrandVideoSection = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const sectionRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"]
  });
  
  const y = useTransform(scrollYProgress, [0, 1], ['0%', '10%']);

  return (
    <section 
      ref={sectionRef}
      data-testid="brand-video-section" 
      className="relative h-[70vh] md:h-[80vh] overflow-hidden bg-[#0E3D24]"
    >
      {/* Background with parallax */}
      <motion.div 
        className="absolute inset-0"
        style={{ y }}
      >
        {!isPlaying ? (
          <>
            <img loading="lazy" 
              src="/videos/brand-poster.jpg" 
              alt="Dilling EL"
              className="w-full h-[120%] object-cover"
            />
            <div className="absolute inset-0 bg-black/40" />
          </>
        ) : (
          <video
            autoPlay
            controls
            className="w-full h-full object-cover"
            onEnded={() => setIsPlaying(false)}
          >
            <source src="/videos/brand-video.mp4" type="video/mp4" />
          </video>
        )}
      </motion.div>

      {/* Play button overlay */}
      {!isPlaying && (
        <div className="relative h-full flex items-center justify-center">
          <motion.button
            onClick={() => setIsPlaying(true)}
            className="group flex flex-col items-center gap-6"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            whileHover={{ scale: 1.05 }}
          >
            <div className="w-24 h-24 md:w-32 md:h-32 rounded-full border-2 border-white/50 flex items-center justify-center group-hover:border-white group-hover:bg-white/10 transition-all duration-300">
              <Play size={40} className="text-white ml-2" fill="white" />
            </div>
            <span className="text-white/80 text-sm tracking-[0.2em] uppercase group-hover:text-white transition-colors">
              Se vores historie
            </span>
          </motion.button>
        </div>
      )}

      {/* Close button when playing */}
      {isPlaying && (
        <button
          onClick={() => setIsPlaying(false)}
          className="absolute top-8 right-8 z-20 w-12 h-12 rounded-full bg-black/50 flex items-center justify-center text-white hover:bg-black/70 transition-colors"
        >
          <X size={24} />
        </button>
      )}
    </section>
  );
};
